import React from "react";
import * as sharedStyled from "../../styled";
import logo from "../../../../resources/bluedot-logo.png";
import Button from "../../../Button";
import { canvasUrls } from "../../../../services/api";

export default ({ region }) => {
  return (
    <sharedStyled.Container>
      <div>
        <sharedStyled.MainContentContainer>
          <sharedStyled.Logo src={logo} alt="logo" />
          <h1>Success</h1>
          <p>
            Your Salesforce Marketing Cloud account has been successfully linked
            to your Canvas account.
          </p>
          <p>
            In the future you can access Canvas directly and the link will be
            maintained
          </p>
          <sharedStyled.ButtonsWrapper>
            <Button onClick={() => window.open(canvasUrls[region], "_blank")}>
              Open Canvas
            </Button>
          </sharedStyled.ButtonsWrapper>
        </sharedStyled.MainContentContainer>
      </div>
    </sharedStyled.Container>
  );
};
